"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTimer = void 0;

// Timer
var setTimer = function setTimer(callback) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  setTimeout(function () {
    if (typeof callback === 'function') {
      callback();
    }
  }, duration);
};

exports.setTimer = setTimer;
//# sourceMappingURL=time.js.map